import { render, staticRenderFns } from "./Pattern.vue?vue&type=template&id=33ff0228&scoped=true"
import script from "./Pattern.vue?vue&type=script&lang=js"
export * from "./Pattern.vue?vue&type=script&lang=js"
import style0 from "./Pattern.vue?vue&type=style&index=0&id=33ff0228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff0228",
  null
  
)

export default component.exports